import { CallIcons, ccfCallActions } from '../ccf-call-conference.slice';
import { updateCallType } from '../../ccf-inbox/ccf-inbox.slice';
import { AppsRounded, VolumeUp } from '@mui/icons-material';
import {
  CcfCallMuteIcon,
  CcfCallHungUpIcon,
  CcfCallRecordIcon,
  CcfCallTransferIcon,
} from '@nice-ccf/ui-controls';
import classes from '../ccf-call-conference.module.scss';

export const callConferenceCommonIcons: CallIcons[] = [
  {
    type: 'toggle',
    icon: <CcfCallMuteIcon viewBox="0 0 20 20" />,
    toggleIcon: <VolumeUp />,
    dispatcherAction: ccfCallActions.resetState,
  },
  {
    type: 'action',
    icon: <CcfCallRecordIcon viewBox="0 0 20 20" fontSize="small" />,
    dispatcherAction: ccfCallActions.resetState,
  },
  {
    type: 'action',
    icon: <AppsRounded />,
    dispatcherAction: ccfCallActions.resetState,
  },
  {
    type: 'action',
    icon: (
      <CcfCallTransferIcon
        viewBox="0 0 20 20"
        fontSize="small"
        style={{ width: '32px', fontSize: '18px' }}
      />
    ),
    dispatcherAction: ccfCallActions.resetState,
    className: `${classes.callControlButtonBordered}`,
  },
  {
    type: 'action',
    icon: <CcfCallHungUpIcon viewBox="0 0 20 20" />,
    dispatcherAction: () => updateCallType('p2p'),
    className: `${classes.iconEnd}`,
  },
];
